export const carbonPrefix = 'cds'
